import { Component, OnInit, Input, Output, EventEmitter, forwardRef, SimpleChanges } from '@angular/core';
import { 
    IonLabel, IonNote, IonIcon
} from '@ionic/angular/standalone';
import { TranslatePipe } from '@ngx-translate/core';
import moment from 'moment';

import { MarvDateToStringPipe } from '@marv/pipes'
import { MarvItemComponent, MarvTagComponent, MarvButtonComponent } from '@marv/components';
import { StoreItem, StoreItemQuota, RetailerLogoComponent, RetailerLogo } from '@app/components';
import { MissionTypeService, StoreService } from '@app/services';

@Component({
    selector: 'app-store-item',
    templateUrl: './item.component.html',
    styleUrls: ['./item.component.scss'],
    imports: [
        IonLabel, IonNote, IonIcon, TranslatePipe, MarvDateToStringPipe,
        forwardRef(() => MarvItemComponent), forwardRef(() => MarvTagComponent), forwardRef(() => MarvButtonComponent), 
        forwardRef(() => RetailerLogoComponent)
    ]
})
export class StoreItemComponent  implements OnInit {

    @Input({alias : 'store', required : true}) store: StoreItem;
    @Input({alias : 'operationId', required : false}) operationId: number|undefined;
    @Input({alias : 'displayNbInterventions', required : false}) displayNbInterventions: boolean = false;
    @Input({alias : 'displaySector', required : false}) displaySector: boolean = false;
    @Input({alias : 'displayScores', required : false}) displayScores: boolean = false;
    @Input({alias : 'displayQuota', required : false}) displayQuota: boolean = false;
    @Input({alias : 'displayBtnRemoveStore', required : false}) displayBtnRemoveStore: boolean = false;
    @Input({alias : 'disabledBtnRemoveStore', required : false}) disabledBtnRemoveStore: boolean = false;
    @Output() onSelectStore = new EventEmitter<StoreItem>();
    @Output() onRemoveStore = new EventEmitter<StoreItem>();

    quotaInfos: StoreItemQuota;

    constructor(
        public missionTypeService: MissionTypeService,
        private storeService: StoreService
    ) { }

    async ngOnInit() {
        if(this.displayQuota){
            // A MODIFIER - Ajouter API pour récupérer les quotas d'un secteur
            /*let quotaInfos = new StoreItemQuota();
            quotaInfos.quotaTotal = 6000;
            quotaInfos.quotaRealized = 1500;
            quotaInfos.quotaPlanned = 500;
            quotaInfos.quotaRemaining = 4000;
            this.quotaInfos = quotaInfos;*/
        }
        
    }
         
    selectStore(){
        this.onSelectStore.emit(this.store);
    }

    removeStore($event: any){
        $event.stopPropagation();
        if(!this.disabledBtnRemoveStore){
            this.onRemoveStore.emit(this.store);
        }
    }    
    
    roundQuota(quota: number): number {
        return Math.floor(quota);
    }
    
}
